class PredictiveSearch extends HTMLElement {
	constructor() {
		super()

		this.input = this.querySelector('input[type="search"]')
		this.form = this.querySelector('form')
		this.predictiveSearchResults = this.querySelector(
			'#predictive-search-results'
		)

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event)
			}, 300).bind(this)
		)
		this.form.addEventListener('reset', () =>
			setTimeout(this.onReset.bind(this), 200)
		)
	}

	onChange() {
		const searchTerm = this.input.value.trim()
		if (!searchTerm.length) {
			return
		}
		this.getSearchResults(searchTerm)
	}

	onReset() {
		this.predictiveSearchResults.innerHTML = ''
	}

	getSearchResults(searchTerm) {
		fetch(
			`/search/suggest?q=${searchTerm}&section_id=predictive-search
				&resources[options][fields]=title,product_type,variants.title,tag`
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(response.status)
				}
				return response.text()
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-predictive-search').innerHTML
				this.predictiveSearchResults.innerHTML = resultsMarkup
			})
			.catch((error) => {
				throw error
			})
	}

	debounce(fn, wait) {
		let t
		return (...args) => {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	}
}

customElements.define('predictive-search', PredictiveSearch)
